import { render, staticRenderFns } from "./ItemsCarousel.vue?vue&type=template&id=e28f9ca2&scoped=true&"
import script from "./ItemsCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ItemsCarousel.vue?vue&type=style&index=0&id=e28f9ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f9ca2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
